import React, { useEffect, useState } from "react";
import { X } from "phosphor-react";
import { useDispatch, useSelector } from "react-redux";
import { getCoupons } from "../../appState/slices/coupon/couponSlice";

const CouponSelector = ({ selectedcoupon, showapplycoupon, setselectedCouponValue, selectedcouponname}) => {
    const selectcoupon = () => {
        selectedcoupon(true);
    };
    // const [couponValue,setCouponvalue] = useState(couponvalue);
    const cart = useSelector(state => state.cart.cart);

    const coupons = useSelector((state) => state.coupon.coupons);

    const applycouponbtn = (value,code) => {
        // setCouponvalue(value);
        setselectedCouponValue(value);
        selectedcouponname(code);
        selectedcoupon(true);
    }
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCoupons({
            price : cart?.totalAmount
        }));
    }, [])

    return (
        <div className="apply-coupon-container">
            <div className="select-coupon-text-container">
                <div className="t3 font-semibold">Select Coupon</div>
                <X
                    className="close-select-coupon"
                    onClick={selectcoupon}
                    size={20}
                />
            </div>
            <div className="coupon-main">
                {coupons.map(coupondetails => {
                    return (
                        <React.Fragment>
                            <hr className="myorders-line"></hr>
                            <div className={`${coupondetails.isEnabled? "" : "disabled "}coupon-container `}>
                                <div className="coupon-name-desc">
                                    <div className="coupon-name t5 font-semibold">{coupondetails.code}</div>
                                    <div className="coupon-desc t7 font-medium">
                                        {coupondetails.description}
                                    </div>
                                </div>
                                <div onClick={() => applycouponbtn(coupondetails.discountValue,coupondetails.code)} className={`${coupondetails.isEnabled? "coupon-btn " : "coupon-btn-disabled" }  t7 font-semibold`}>APPLY COUPON</div>
                            </div>
                        </React.Fragment>
                    )
                })}


            </div>

        </div>
    )
}

export default CouponSelector;